import Immutable, { List } from 'immutable';
import { AppState, AppStateActionParams } from 'records/AppState';
import { PunchQuery } from 'records/PunchQuery';
import queryPunches from 'utils/queryPunches';

export interface PunchQueryActions {
  setPunchQuery: (
    actionParams: AppStateActionParams,
    nextPunchQuery: PunchQuery
  ) => AppState;
  setPunchTableQuery: (
    actionParams: AppStateActionParams,
    nextPunchQuery: PunchQuery
  ) => AppState;
  queryPunches: (actionParams: AppStateActionParams) => AppState;
  initPunchQuery: (actionParams: AppStateActionParams) => AppState;
  addAssigneesToPunchQuery: (
    actionParams: AppStateActionParams,
    assignees: Immutable.OrderedSet<string>
  ) => AppState;
  addGroupAssigneesToPunchQuery: (
    actionParams: AppStateActionParams,
    groupAssignees: Immutable.OrderedSet<string>
  ) => AppState;
}

const punchQueryActions: PunchQueryActions = {
  setPunchQuery: (
    { state }: AppStateActionParams,
    nextPunchQuery: PunchQuery
  ): AppState => {
    // probably want to update queriedPunches here.
    const { punches, sheets, markups, projectGroups } = state();
    const qPunches = queryPunches(
      punches,
      sheets,
      markups,
      nextPunchQuery,
      projectGroups
    );
    return state()
      .set('punchQuery', nextPunchQuery)
      .set('queriedPunches', Immutable.List(qPunches.keys()));
  },

  setPunchTableQuery: (
    { state }: AppStateActionParams,
    nextPunchQuery: PunchQuery
  ): AppState => {
    const { punches, sheets, markups, projectGroups } = state();
    const qPunches = queryPunches(
      punches,
      sheets,
      markups,
      nextPunchQuery,
      projectGroups
    );
    return state()
      .set('punchTableQuery', nextPunchQuery)
      .set('queriedPunches', Immutable.List(qPunches.keys()));
  },

  queryPunches: ({ state }: AppStateActionParams): AppState => {
    const { punches, sheets, markups, punchQuery, projectGroups } = state();
    const qPunches = queryPunches(
      punches,
      sheets,
      markups,
      punchQuery,
      projectGroups
    );
    const queriedPunches = Immutable.List(qPunches.keys());

    return state().set('queriedPunches', queriedPunches);
  },

  initPunchQuery: ({ state }: AppStateActionParams): AppState => {
    const { punches, sheets, markups, projectGroups } = state();

    const punchQuery = new PunchQuery();

    const qPunches = queryPunches(
      punches,
      sheets,
      markups,
      punchQuery,
      projectGroups
    );

    return state()
      .set('punchQuery', punchQuery)
      .set('queriedPunches', Immutable.List(qPunches.keys()));
  },

  addAssigneesToPunchQuery: (
    { state }: AppStateActionParams,
    assignees: Immutable.OrderedSet<string>
  ): AppState => {
    return state().updateIn(['punchQuery', 'assignees'], (a) => {
      return a.concat(assignees);
    });
  },
  addGroupAssigneesToPunchQuery: (
    { state }: AppStateActionParams,
    groupAssignees: Immutable.OrderedSet<string>
  ): AppState => {
    return state().updateIn(['punchQuery', 'groupAssignees'], (a) => {
      return a.concat(groupAssignees);
    });
  },
};

export default punchQueryActions;
